<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <NewDocumentList
          redirectView="documentsExpense"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
};
</script>
